import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.jpeg";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.jpeg";
import Work9 from "../../assets/work9.png";
import Work10 from "../../assets/work10.jpeg";
import photo_distribution from "../../assets/portfolio/photo_distribution.jpg";
import smartnas from "../../assets/portfolio/smartnas.png";
import dealerapp from "../../assets/portfolio/dealer_app.png";
import eclinic from "../../assets/portfolio/eclinic.png";
import alcohol_checker from "../../assets/portfolio/alcohol_checker.png";
import truck_matching from "../../assets/portfolio/truck_matching.png";

export const projectsData = [
  {
    image: alcohol_checker,
    title: "アルコールチェッカー",
    responsibility: 1,
  },
  {
    image: photo_distribution,
    title: "写真配信サービス",
    responsibility: 3,
  },
  {
    image: eclinic,
    title: "eクリニック",
    responsibility: 3,
  },
  {
    image: smartnas,
    title: "SmartNas - Telecom's Selfcare App",
    responsibility: 2,
    link: "https://play.google.com/store/apps/details?id=net.omobio.smartsc&hl=en",
  },
  {
    image: dealerapp,
    title: "Smart Dealer App - Telecom's Selfcare App",
    responsibility: 2,
    link: "https://play.google.com/store/apps/details?id=com.cammob.smart.sim_card",
  },
  {
    image: truck_matching,
    title: "ラックのマッチング",
    responsibility: 3,
  },
  {
    image: Work1,
    title: "NFT Marketplace",
    responsibility: 3,
    link: "https://www.behance.net/gallery/173477835/NFT-Marketplace",
  },
  {
    image: Work2,
    title: "QuickEat - Food Delivery",
    responsibility: 3,
    link: "https://www.behance.net/gallery/173471833/QuickEat-Food-Delivery",
  },
  {
    image: Work3,
    title: "Slecret",
    responsibility: 4,
    link: "https://slecret.com/",
  },
  {
    image: Work4,
    title: "Your Space",
    responsibility: 3,
    link: "https://www.behance.net/gallery/138036703/Your-Space-App-UXUI-Design",
  },
  {
    image: Work5,
    title: "Visit Cambodia",
    responsibility: 3,
    link: "https://www.behance.net/gallery/173368585/Visit-Cambodia-Mobile-App?",
  },
  {
    image: Work6,
    title: "Tesla UI Clone",
    responsibility: 1,
    link: "https://github.com/visaludam/tesla-clone",
  },
  {
    image: Work7,
    title: "E-commerce with Stripe",
    responsibility: 1,
    link: "https://github.com/visaludam/ecommerce-with-stripe",
  },
  {
    image: Work9,
    title: "Signal UI Clone",
    responsibility: 1,
    link: "https://github.com/visaludam/signal-clone",
  },
  {
    image: Work10,
    title: "Heineken Dealer App",
    responsibility: 2,
    link: "https://www.behance.net/gallery/173367583/Heineken-Dealer-App-Redesign",
  },
];
